export const documentTemplates = {
    license: {
        key: 'public_file_link_license',
        text: 'Лицензия'
    },
    certificate: {
        key: 'public_file_link_certificate',
        text: 'Свидетельство'
    },
    site_rules: {
        key: 'public_file_link_site_rules',
        text: 'Правила'
    },
    privacy_policy: {
        key: 'public_file_link_privacy_policy',
        text: 'Политика конфиденциальности'
    },
    link_excerpt: {
        key: 'public_file_link_excerpt',
        text: 'Выписка из Положения'
    },
    rules_for_visiting: {
        key: 'public_file_link_rules_for_visiting',
        text: 'Правила посещения'
    },
    public_offer: {
        key: 'public_file_link_public_offer',
        text: 'Публичная оферта'
    }
};

export const gamersTemplates = {
    responsible_game: {
        key: 'public_file_link_responsible_game',
        text: 'Ответственная игра'
    }
};



// WEBPACK FOOTER //
// ./_layout/js/constants_by.js